import { Injectable } from '@angular/core';

@Injectable()
export default class BrowserWindowObjectService {

  getNativeWindow(): any {
    return window;
  }
  searchCaptureOpen(route: string) {
    window.open(`${route}`, '_blank', `menubar=1,  scrollbars=1, resizeable`);
  }
  watsonShowGuideline(route: string) {
    window.open(`${route}`, '_blank', `menubar=1,  scrollbars=1, resizeable`);
  }
  openWindowInNewWindowByRoute(route: string, title: string, width: number, height: number) {
    window.open(`#${route}`, 'NewWin', `menubar=1, width=${width}, height= ${height}, scrollbars=1, resizeable, titlebar=${title}`);
  }

  openInNewWindowByRoute(route: string, name: string, title: string, width: number, height: number) {
    const wComment = window.open(`#${route}`, `${name}`, '', true);
    wComment.close();
    window.open(`#${route}`, `${name}`, `menubar=1, width=${width}, height= ${height}, scrollbars=1, resizeable, titlebar=${title}`, true);
  }
  openWindowITabByRoute(route: string, title: string) {
    window.open(`#${route}`, `titlebar=${title}`);
  }
  scrollToTopOfPage() {
    window.scrollTo(0, 0);
  }

  goBackOnePage() {
    window.history.back();
  }
}



// WEBPACK FOOTER //
// ./src/services/browserWindowObjectService.ts